import { joinPath } from '..';

const ROOT_PATH = '/signup-application';
const REFERRAL_REQUEST_COMPLETED_PATH = joinPath(ROOT_PATH, '/completed');

export const ReferralPaths = {
  ROOT_PATH,
  REFERRAL_REQUEST_COMPLETED_PATH,
} as const;
